export class UserPrefsModel {
  public FavoriteWellIds: Array<number> = new Array<number>();

  constructor() {
    this.FavoriteWellIds = new Array<number>();
  }
}
